import { ReactNode } from 'react';
import { Badge } from 'react-bootstrap';

// One colour family per tone (green = success, red = danger, amber = warning, blue = primary,
// teal = info, grey = neutral, dark = dark): theme.css `.admin-badge-solid--<tone>`.
export type SolidBadgeTone = 'green' | 'red' | 'amber' | 'blue' | 'teal' | 'grey' | 'dark';

type Props = {
  tone: SolidBadgeTone;
  className?: string;
  children: ReactNode;
};

/**
 * A small badge with white text in both themes on a solid fill dark enough to carry it (5:1 or more against
 * white). Deliberately no Bootstrap `variant`: on User View, `.userview-page .badge-<variant>` pins the fills
 * with !important and `.userview-page span` repaints badge text with the theme's text colour. The
 * `admin-badge-solid` classes in theme.css are reached by neither.
 */
export function SolidBadge({ tone, className, children }: Props): JSX.Element {
  return (
    <Badge className={['admin-badge-solid', `admin-badge-solid--${tone}`, className].filter(Boolean).join(' ')}>
      {children}
    </Badge>
  );
}
